<template>
    <v-container fluid ma-0 pa-0 fill-height>
        <div id="map"></div>
    </v-container>
</template>

<style>
    #map {
        width: 100%;
        height: 100%;
    }

    span.place_title {
        font-family: "Georgia", serif;
        font-variant-caps: small-caps;
        font-size: 1.3em;
        font-weight: bold;
        display: block;
        padding: 0 0 5px 5px;
        text-decoration: underline;
    }

    span.gps {
        font-style: italic;
        font-size: .8em;
    }

    div.card_content {
    }

    div.card_content ul {
        list-style-type: square;
    }

    div.cluster div {
        border: 0 !important;
    }
</style>

<script>
    const SMap = window.SMap;
    const JAK = window.JAK;

    const DB_URL = "/data/db.json";
    const FILES_PREFIX = "/data/files/"

    export default {
        name: 'MapyCzMap',
        mounted() {
            this.$nextTick(function () {
                this.loadMap()
            })
        },
        methods: {
            loadMap: function () {
                let center = SMap.Coords.fromWGS84(15.3386383, 49.7437572);
                let m = new SMap(JAK.gel("map"), center, 8);
                m.addDefaultControls();

                // reactive to window size
                let sync = new SMap.Control.Sync({bottomSpace: 0});
                m.addControl(sync);

                // add layers switch
                m.addDefaultLayer(SMap.DEF_OPHOTO);
                m.addDefaultLayer(SMap.DEF_TURIST).enable();
                m.addDefaultLayer(SMap.DEF_BASE);

                let layerSwitch = new SMap.Control.Layer({
                    width: 65,
                    items: 4,
                    page: 4
                });
                layerSwitch.addDefaultLayer(SMap.DEF_BASE);
                layerSwitch.addDefaultLayer(SMap.DEF_OPHOTO);
                layerSwitch.addDefaultLayer(SMap.DEF_TURIST);
                m.addControl(layerSwitch, {left: "8px", top: "9px"});

                this.addMarkers(m)
            },
            addMarkers: function (m) {
                let layer = new SMap.Layer.Marker();

                let clusterer = new SMap.Marker.Clusterer(m);
                layer.setClusterer(clusterer)

                m.addLayer(layer).enable();

                fetch(DB_URL)
                    .then((response) => {
                        return response.json();
                    }).then((data) => {
                    data.forEach(place => {
                        let [lon, lat] = place.loc.split(", ").map(s => s.slice(0, -1))

                        layer.addMarker(this.createMarker(lon, lat, place.name, place.links, place.files));
                    })
                })
            },
            createMarker: function (lon, lat, name, links, files) {
                console.log(`Adding marker: ${name} ${lat} ${lon} ${links} ${files}`);

                let markerLayout = JAK.mel("div");
                let img = JAK.mel("img", {src: "/imgs/climbing_icon.png"});
                markerLayout.appendChild(img);

                let markerOptions = {url: markerLayout, anchor: {left: 16, top: 16}};
                let marker = new SMap.Marker(SMap.Coords.fromWGS84(lat, lon), null, markerOptions);

                let card = new SMap.Card();
                card.setSize(400, 250);
                card.getHeader().innerHTML = `<span class="place_title">${name}</span>`;
                card.getBody().innerHTML = this.markerCard(lat, lon, links, files);

                marker.decorate(SMap.Marker.Feature.Card, card);

                return marker;
            },
            markerCard: function (lat, lon, links, files) {
                let links_html = "<br><strong>Odkazy:</strong>\n<ul>"
                links.forEach(link => {
                    links_html += `<li><a href='${link.target}' target="_blank">${link.name}</a></li>\n`
                })
                links_html += "</ul>"

                let files_html = "<br><strong>Soubory:</strong>\n<ul>"
                files.forEach(file => {
                    files_html += `<li><a href='${FILES_PREFIX}${file.path}' target="_blank">${file.name}</a></li>\n`
                })
                files_html += "</ul>"

                return `
                <div class="card_content">
                    <span class="gps">GPS: ${lon}N, ${lat}E</span>

                    ${files_html}

                    ${links_html}
                </div>
                `;
            }
        },

        data: () => ({}),
    }
</script>
